define('ShippingCountdown', [
  'ShippingByLocation',
  'ShippingCountdown.View'
], function ShippingCountdown(ShippingByLocation, ShippingCountdownView) {
  'use strict';

  return {
    /**
     * @param {ComponentContainer} container
     */
    mountToApp: function mountToApp(container) {
      /** @type PDP */
      var pdp = container.getComponent('PDP');

      this.addChildView(container, pdp.PDP_QUICK_VIEW);
      this.addChildView(container, pdp.PDP_FULL_VIEW);
    },

    /**
     * @param {ComponentContainer} container
     * @param {String} viewId
     */
    addChildView: function addChildView(container, viewId) {
      /** @type PDP */
      var pdp = container.getComponent('PDP');

      pdp.addChildViews(viewId, {
        'Product.Options': {
          Countdown: {
            childViewConstructor: function LocationsTableViewConstructor() {
              var model = ShippingByLocation.forCurrentProduct(container);
              var view = new ShippingCountdownView({ model: model });
              model.setup().done(function doneLoad() {
                view.render();
              });
              return view;
            }
          }
        }
      });
    }
  };
});
